import Vue from 'vue'
import { Button,Dialog,Input,Carousel,CarouselItem,Tag,Calendar,Select,Option,Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tag)
Vue.use(Calendar)
Vue.use(Select)
Vue.use(Option)

Vue.prototype.$message = Message

new Vue({
  render: h => h(App),
}).$mount('#app')
